<template>
  <MainLayout>
    <template #header>
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-2xl font-bold text-gray-900">
            Мои дэшборды
          </h1>
          <p class="text-sm text-gray-500 mt-1">
            Создание и управление дэшбордами
          </p>
        </div>
        <button class="btn-primary">
          <PlusIcon class="h-4 w-4 mr-2" />
          Создать дэшборд
        </button>
      </div>
    </template>

    <div class="card">
      <div class="card-body">
        <div class="text-center py-12">
          <ChartBarIcon class="h-12 w-12 mx-auto text-gray-400 mb-4" />
          <h3 class="text-lg font-medium text-gray-900 mb-2">
            Пользовательские дэшборды
          </h3>
          <p class="text-gray-500 mb-6">
            Создание и редактирование дэшбордов в разработке
          </p>
          <button class="btn-primary">
            Создать первый дэшборд
          </button>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script setup>
import { PlusIcon, ChartBarIcon } from '@heroicons/vue/24/outline'
import MainLayout from '@/components/layout/MainLayout.vue'
</script>